export default __webpack_public_path__ + "static/media/poly.0d9d7d87.svg";